import { LegalShell } from '@/pages/legal/LegalShell';

export default function Devoluciones() {
  return (
    <LegalShell title="Devoluciones y garantías" updated="2026" testId="returns-page">
      <p>Esta política describe cómo gestionamos devoluciones y reembolsos en el flujo operativo actual.</p>
      <h2>1. Solicitud de devolución</h2>
      <ul>
        <li>Puedes solicitar una devolución desde tus pedidos cuando el producto llegue defectuoso, incompleto o no corresponda a lo pedido.</li>
        <li>Cada devolución se gestiona con la tienda que atendió tu pedido mediante un proceso interno de autorización (RMA) y recepción.</li>
      </ul>
      <h2>2. Reembolsos</h2>
      <ul>
        <li>El reembolso del importe de los productos se tramita por el mismo medio externo acordado para el pago. La plataforma no ejecuta cobros ni transferencias automáticas.</li>
        <li>Los gastos de envío se tratan por separado del subtotal de productos.</li>
      </ul>
      <h2>3. Efecto en Barrio Puntos</h2>
      <ul>
        <li>Si un pedido reembolsado había generado puntos, esos puntos se ajustan de forma proporcional al importe devuelto.</li>
        <li>Si ya habías redimido puntos en ese pedido, el ajuste se refleja en tu saldo de forma auditada, pudiendo quedar un saldo pendiente hasta regularizarse.</li>
      </ul>
      <h2>4. Plazos de entrega y ventanas</h2>
      <p>Los tiempos de entrega corresponden a rangos declarados por cada vendedor según su cobertura; no se calculan a partir de tráfico o rutas en tiempo real.</p>
      <h2>5. Ayuda</h2>
      <p>Si necesitas apoyo con una devolución, escríbenos desde <a className="underline" href="/contacto">Contacto</a> indicando el número de pedido.</p>
    </LegalShell>
  );
}
